// extracted by mini-css-extract-plugin
export var roundedRadius = "page-module--roundedRadius--27fec";
export var softSquareRadius = "page-module--softSquareRadius--959bc";
export var spacer = "page-module--spacer--c7f52";